import { userApi } from "shared/api/userApi";

export const getUserRequest = (options = {}) => {
  return userApi.getUser(options);
};
